var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isColorful
    ? _c("span", {
        class: "icon-" + _vm.icon,
        style: _vm.size != null ? "font-size: " + _vm.size + "px" : ""
      })
    : _c(
        "span",
        {
          class: "icon-" + _vm.icon,
          style: _vm.size != null ? "font-size: " + _vm.size + "px" : ""
        },
        _vm._l(_vm.numberOfColors, function(index) {
          return _c("span", {
            key: index,
            class: "icon-" + _vm.icon + " path" + index
          })
        }),
        0
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eb20663", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb20663","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/kaledo-components/src/components/KIcon.vue
// module id = 2026
// module chunks = 1609